import React from 'react';

const Step3Spawn = ({ state, callbacks }) => {
  if (state.objectType === 'texture') {
    return (
      <div className="w-full bg-transparent p-0">
        <p className="text-sm text-dark-text-muted leading-relaxed">Für 2D-Texturen werden die Objekte automatisch positioniert.</p>
      </div>
    );
  }

  return (
    <div className="w-full bg-transparent p-0 space-y-4">
      {state.randomizers.spawn && (
        <>
          <div>
            <label className="block mb-2 text-xs font-medium text-dark-text-muted tracking-tight">Anzahl der Objekte</label>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1.5">
                <label className="text-xs text-dark-text-muted tracking-tight font-medium">Minimum</label>
                <input
                  type="number"
                  value={state.modelSpawn.minObjects}
                  onChange={(e) => callbacks.setModelSpawn({ ...state.modelSpawn, minObjects: parseInt(e.target.value) || 1 })}
                  min="1"
                  max="100"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
              </div>
              <div className="space-y-1.5">
                <label className="text-xs text-dark-text-muted tracking-tight font-medium">Maximum</label>
                <input
                  type="number"
                  value={state.modelSpawn.maxObjects}
                  onChange={(e) => callbacks.setModelSpawn({ ...state.modelSpawn, maxObjects: parseInt(e.target.value) || 5 })}
                  min="1"
                  max="100"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
              </div>
            </div>
          </div>

          <div>
            <label className="block mb-2 text-xs font-medium text-dark-text-muted tracking-tight">Skalierung (Multiplikator)</label>
            <input
              type="number"
              value={state.modelSpawn.scale}
              onChange={(e) => callbacks.setModelSpawn({ ...state.modelSpawn, scale: parseFloat(e.target.value) || 1 })}
              min="0.1"
              max="5"
              step="0.1"
              className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
            />
            <div className="text-xs text-dark-text-muted mt-2 leading-relaxed">
              ⚡ <strong className="text-dark-text-secondary">Automatische Skalierung aktiv:</strong> Alle Modelle werden automatisch auf eine einheitliche Größe skaliert (2 Einheiten).<br />
              Dieser Wert multipliziert die automatische Skalierung. Standard: 1.0 (keine zusätzliche Skalierung).
            </div>
          </div>

          <div>
            <label className="block mb-2 text-xs font-medium text-dark-text-muted tracking-tight">Positionierungsbereich (Minimum)</label>
            <div className="grid grid-cols-3 gap-3">
              <div className="space-y-1.5">
                <label className="text-xs text-dark-text-muted tracking-tight font-medium">X</label>
                <input
                  type="number"
                  value={state.modelSpawn.minPosition.x}
                  onChange={(e) => callbacks.setModelSpawn({ 
                    ...state.modelSpawn, 
                    minPosition: { ...state.modelSpawn.minPosition, x: parseFloat(e.target.value) || -10 }
                  })}
                  step="0.1"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
              </div>
              <div className="space-y-1.5">
                <label className="text-xs text-dark-text-muted tracking-tight font-medium">Y</label>
                <input
                  type="number"
                  value={state.modelSpawn.minPosition.y}
                  onChange={(e) => callbacks.setModelSpawn({ 
                    ...state.modelSpawn, 
                    minPosition: { ...state.modelSpawn.minPosition, y: parseFloat(e.target.value) || -10 }
                  })}
                  step="0.1"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
              </div>
              <div className="space-y-1.5">
                <label className="text-xs text-dark-text-muted tracking-tight font-medium">Z</label>
                <input
                  type="number"
                  value={state.modelSpawn.minPosition.z}
                  onChange={(e) => callbacks.setModelSpawn({ 
                    ...state.modelSpawn, 
                    minPosition: { ...state.modelSpawn.minPosition, z: parseFloat(e.target.value) || -10 }
                  })}
                  step="0.1"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
              </div>
            </div>
          </div>

          <div>
            <label className="block mb-2 text-xs font-medium text-dark-text-muted tracking-tight">Positionierungsbereich (Maximum)</label>
            <div className="grid grid-cols-3 gap-3">
              <div className="space-y-1.5">
                <label className="text-xs text-dark-text-muted tracking-tight font-medium">X</label>
                <input
                  type="number"
                  value={state.modelSpawn.maxPosition.x}
                  onChange={(e) => callbacks.setModelSpawn({ 
                    ...state.modelSpawn, 
                    maxPosition: { ...state.modelSpawn.maxPosition, x: parseFloat(e.target.value) || 10 }
                  })}
                  step="0.1"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
              </div>
              <div className="space-y-1.5">
                <label className="text-xs text-dark-text-muted tracking-tight font-medium">Y</label>
                <input
                  type="number"
                  value={state.modelSpawn.maxPosition.y}
                  onChange={(e) => callbacks.setModelSpawn({ 
                    ...state.modelSpawn, 
                    maxPosition: { ...state.modelSpawn.maxPosition, y: parseFloat(e.target.value) || 10 }
                  })}
                  step="0.1"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
              </div>
              <div className="space-y-1.5">
                <label className="text-xs text-dark-text-muted tracking-tight font-medium">Z</label>
                <input
                  type="number"
                  value={state.modelSpawn.maxPosition.z}
                  onChange={(e) => callbacks.setModelSpawn({ 
                    ...state.modelSpawn, 
                    maxPosition: { ...state.modelSpawn.maxPosition, z: parseFloat(e.target.value) || 10 }
                  })}
                  step="0.1"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
              </div>
            </div>
          </div>

          <div>
            <label className="block mb-2 text-xs font-medium text-dark-text-muted tracking-tight">Minimaler Abstand zwischen Objekten</label>
            <input
              type="number"
              value={state.modelSpawn.minDistance}
              onChange={(e) => callbacks.setModelSpawn({ ...state.modelSpawn, minDistance: parseFloat(e.target.value) || 2 })}
              min="0"
              max="50"
              step="0.1"
              className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
            />
          </div>

          <div>
            <label className="block mb-2 text-xs font-medium text-dark-text-muted tracking-tight">Rotationsbereich (in Grad)</label>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1.5">
                <label className="text-xs text-dark-text-muted tracking-tight font-medium">Minimum</label>
                <input
                  type="number"
                  value={state.modelSpawn.minRotation}
                  onChange={(e) => callbacks.setModelSpawn({ ...state.modelSpawn, minRotation: parseFloat(e.target.value) || 0 })}
                  min="-180"
                  max="180"
                  step="1"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
              </div>
              <div className="space-y-1.5">
                <label className="text-xs text-dark-text-muted tracking-tight font-medium">Maximum</label>
                <input
                  type="number"
                  value={state.modelSpawn.maxRotation}
                  onChange={(e) => callbacks.setModelSpawn({ ...state.modelSpawn, maxRotation: parseFloat(e.target.value) || 360 })}
                  min="-180"
                  max="180"
                  step="1"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Step3Spawn;
